import * as yup from "yup";

import {
  Avatar,
  Button,
  Dialog,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  List,
  MenuItem,
  Paper,
  Slide,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { cyan, red } from "@mui/material/colors";
import {
  useAddNewMethodMutation,
  useDeleteCvMethodMutation,
  useEditCvMethodMutation,
} from "../../../lib/cvsSlice";

import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import useFormPersist from "react-hook-form-persist";
import { yupResolver } from "@hookform/resolvers/yup";

const methodSchema = yup.object().shape({
  group: yup.string().required("Method group is required"),
  description: yup.string().required("Method description is required"),
  excludeInCv: yup.boolean(),
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Method = ({ method, cvId }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState();
  const [methodState, setMethodState] = useState(method)
  const [methodId, setMethodId] = useState();
  const [methodElmnt, setMethodElement] = useState(null);

  const handleOpen = (mode) => {
    setOpen(true);
    setMode(mode);
  };

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(methodSchema),
    defaultValues: {
      group: "",
      description: "",
      excludeInCv: false,
    },
  });

  const [addNewMethod] = useAddNewMethodMutation();

  const submitResults = async (e) => {
    const newMethod = e;
    await addNewMethod({ cvId, method: [newMethod] }).unwrap();
    handleClose();
    method.push(newMethod); // add the new skill to the existing array
    toast.success("Method  added successfully");
  };

  const [deleteMethod] = useDeleteCvMethodMutation();

  const handleRemove = async (item) => {
    await deleteMethod({ cvId, methodId: item }).unwrap();
    const updatedCvMethods = methodState.filter((method) => method._id !== item);
    setMethodState(updatedCvMethods);
    method.splice(method.findIndex((method) => method._id === item), 1);
    setMethodState([...method]);
    toast.info("Method removed successfully");
  };


  const [editCvMethod] = useEditCvMethodMutation();

  const handleEdit = (methodId, mode) => {
    setOpen(true);
    setMode(mode);
    setMethodId(methodId);
  };

  
  const handleInputChange = (event, methodId, fieldName) => {
    const methodElement = method.find((method) => method._id === methodId);
    methodElement[fieldName] = event.target.value;
    const updatedMethod = method.map((method) => {
      if (method._id === methodId) {
        return { ...method, [fieldName]: event.target.value };
      }
      return method;
    });
    setMethodState(updatedMethod);
  };

  const handleToggleChange = (methodId, fieldName, updatedValue) => {
    const updatedMethod = method.map((method) => {
    if (method._id === methodId) {
    method[fieldName] = updatedValue;
    }
    return method;
    });
    
    setMethodState(updatedMethod);
    setMethodElement(updatedMethod.find((method) => method._id === methodId)); // Update the certElement in the state
    methodElement.excludeInCv = updatedValue;
    };

  const methodNames = [
    "DSDM",
    "Scrum",
    "Extreme programming",
    "Agile",
    "Kanban",
  ];

  useFormPersist("method", {
    watch,
    setValue,
    storage: window.localStorage, // default window.sessionStorage
  });

  useEffect(() => {
    const data = localStorage.getItem("method");
    if (data !== null) JSON.parse(data);
  }, []);

  useEffect(() => {
    localStorage.setItem("method", JSON.stringify(method));
  }, [method]);


  const methodElement = method.find((methods)=> methods._id === methodId);
  
     //Edit mode functionality
     const renderSingleElement = () => {
      return (
        <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={12}>
              <Controller
                name="group"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Category"
                    fullWidth
                    autoFocus
                    SelectProps={{
                      MenuProps: {
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                      },
                    }}
                    value = {methodElement.group}
                    onChange={(e) => handleInputChange(e, methodId, "group")}
                    error={!!errors.group}
                    helperText={errors?.group ? errors.group?.message : ""}
                  >
                    {methodNames.map((method) => (
                      <MenuItem value={method} key={method}>
                        {method}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="description"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Description"
                    multiline
                    maxRows={6}
                    fullWidth
                    error={!!errors.description}
                    value = {methodElement.description}
                    onChange={(e) => handleInputChange(e, methodId, "description")}
                    helperText={
                      errors?.description ? errors.description?.message : ""
                    }
                  />
                )}
              />
            </Grid>
          </Grid>
        );
      };

      const submitEditResults = async () => {
        await editCvMethod({
          cvId,
          methodId,
          method: [methodElement],
        }).unwrap();
        handleClose();
        toast.info("method updated successfully");
      };


  return (
    <div id="Methods">
      <ToastContainer autoClose={1500} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper style={{ marginTop: "20px", padding: "15px" }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: "5px" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={2}
                  // justifyContent="center"
                  // alignItems="center"
                >
                  <Grid item xs={9}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      component="div"
                      sx={{ p: 2, pb: 0 }}
                    >
                      Methods
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <IconButton
                      aria-label="add"
                      onClick={() => handleOpen("add")}
                    >
                      <AddIcon color="primary" />
                    </IconButton>
                  </Grid>
                  <Grid item xs={1}>
                    <IconButton
                      aria-label="edit"
                      onClick={() => handleOpen("edit")}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {method?.map((method) => (
                  <List key={method._id} style={{ padding: "0px" }}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: cyan[700] }}>
                          <StorageOutlinedIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        style={{ paddingLeft: "10px" }}
                        primary={
                          <Typography variant="subtitle2" components="div">
                            Group: {method.group}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="caption" display="block">
                            Description: {method.description}
                            <Typography variant="caption" display="block">
                            Exclude in cv: {method.excludeInCv ? "Yes" : "No"}
                            </Typography>
                          </Typography>
                          
                        }
                      />
                    </ListItem>
                  </List>
                ))}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {mode === "add" && (
          <form autoComplete="off" onSubmit={handleSubmit(submitResults)}>
            <DialogTitle>Add New Method</DialogTitle>
            <DialogContent dividers={true}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                style={{ marginTop: "10px" }}
              >
                <Grid item xs={12}>
                  <Controller
                    name="group"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        label="Category"
                        fullWidth
                        autoFocus
                        SelectProps={{
                          MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "center",
                            },
                          },
                        }}
                        error={!!errors.group}
                        helperText={errors?.group ? errors.group?.message : ""}
                      >
                        {methodNames.map((method) => (
                          <MenuItem value={method} key={method}>
                            {method}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Description"
                        multiline
                        maxRows={6}
                        fullWidth
                        error={!!errors.description}
                        helperText={
                          errors?.description ? errors.description?.message : ""
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                style={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}
        {mode === "edit" && (
          <form>
            <DialogTitle>Edit/Remove Method</DialogTitle>
            <DialogContent dividers={true}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                style={{ marginTop: "5px" }}
              >
                <Grid item xs={12}>
                  {method?.map((method) => (
                    <List key={method._id}>
                      <ListItem
                        style={{ marginRight: "-2rem" }}
                        secondaryAction={
                          <Stack alignItems="left" direction="row">
                            <IconButton
                              aria-label="edit"
                              onClick={() => handleEdit(method._id, "editnew")}
                            >
                              <EditIcon color="primary" />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleRemove(method._id)}
                            >
                              <DeleteIcon style={{ color: red[400] }} />
                            </IconButton>
                          </Stack>
                        }
                      >
                        <ListItemText
                          style={{ paddingRight: "20px", margin: "0px" }}
                          primary={
                            <Typography variant="subtitle2" component="div">
                              Group: {method.group +
                                (method.id ? " | " + method?.id : " ")}
                            </Typography>
                          }
                          secondary={
                            <Typography variant="caption" display="block">
                            Description: {method.description}
                            <Typography variant="caption" display="block">
                            Exclude in cv: {method.excludeInCv ? "Yes" : "No"}
                            </Typography>
                            </Typography>
                          }
                        />
                      </ListItem>
                    </List>
                  ))}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                style={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                      disabled
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}

        {mode === "editnew" && (
          <form
            autoComplete="off"
            onSubmit={() => {
              submitEditResults();
            }}
          >
            <DialogTitle>Edit Method</DialogTitle>
            <DialogContent dividers={true}>
              {renderSingleElement()}
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                style={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}

      </Dialog>
    </div>
  );
};

export default Method;